import initPeopleFilter from './components/people/filter';
import initPeopleDirectory from './components/people/directory';

const peopleFilter = document.querySelector('.js-people-filter');

if (peopleFilter) {
    initPeopleFilter(peopleFilter);
}

const peopleDirectory = document.querySelector('.js-people-directory');

if (peopleDirectory) {
    initPeopleDirectory(peopleDirectory);
}
